import React from 'react';

const POSContext = React.createContext();

export const POSCheckoutScreenContext = React.createContext();

export default POSContext;
